//Import
import React from "react";
import styled from "styled-components";
import styles from "./ModalVerAbonos_styles";
import { Table } from "antd";
//Components
import ModalHeader from "../ModalHeader";
import ModalContent from "../ModalContent";
import ModalBottom from "../ModalBottom";
import ModalCronograma from "../ModalCronograma";

// External components
import { Tabs } from "antd";
import { formatNumber } from "../../helpers/formatNumber";
import {formatDate} from "../../helpers/formatDate";
const callback = (key) => {};

/**
 *
 * Props:
 * type:String = Show modaltype 2 Options. "centered" "bottom"
 * show:Boolean = Modal Visibility
 * w:String = Modal width in css values
 * opacity:String / Number = Layout opacity values 0 to 1, 0.5 by default
 */

// Componente base
const Modal_base = ({
  dataModalDetalle,
  closeModalDetalle,
  show,
  w,
  opacity,
  dataModalDetalleAbonos,
  dataModalDetalleCuotas,
  ...props
}) => {

  //Modal type bottom
  const modalBottom = () => {
    const colmuns = [
      {
        title: "Valor",
        dataIndex: "monto_total",
        render: (valor_abono) => formatNumber(valor_abono),
      },
      {
        title: "Saldo",
        dataIndex: "saldo_pendiente",
        render: (saldo) => formatNumber(saldo),
      },
        {
            title: "M. Pago",
            dataIndex: "metodo_pago",
        },
      {
        title: "Fecha",
        dataIndex: "created_at",
        render: (fecha) => formatDate(fecha),
      },
    ];

    const hasData = dataModalDetalle && dataModalDetalle !== "";
    const hasDataAbonos = dataModalDetalleAbonos && dataModalDetalleAbonos !== "";

    const abonosFiltrados = dataModalDetalleAbonos?.abonos || [];

    const dataCreditoDetalle = hasData ? dataModalDetalle.credito : "";

    const mostrarCronograma =
      dataModalDetalleCuotas !== "" &&
      Array.isArray(dataModalDetalleCuotas?.cuotas) &&
      dataModalDetalleCuotas.cuotas.length > 0;

    const items = [
      {
        key: "1",
        label: "Pago",
        children: hasDataAbonos ? (
            <Table
                columns={colmuns}
                dataSource={abonosFiltrados}
                pagination={false}
                rowKey="id"
            />
        ) : null,
      },
      {
        key: "2",
        label: "Info General",
        children: hasData ? (
            <>
              <p>
                <strong>Fecha Creación:</strong>{" "}
                {formatDate(dataModalDetalle.credito?.created_at)}
              </p>
              <p>
                <strong>Valor: </strong>{" "}
                {formatNumber(dataModalDetalle.credito?.monto_principal)}
              </p>
              <p>
                <strong>Seguro: </strong>{" "}
                {formatNumber(dataModalDetalle.credito?.seguro)}
              </p>
              <p>
                <strong>Saldo:</strong>{" "}
                {formatNumber(dataModalDetalle.saldo_pendiente)}
              </p>
              <p>
                <strong>Valor Cuota: </strong>{" "}
                {formatNumber(dataModalDetalle.credito?.valor_cuota)}
              </p>
                <p>
                    <strong>Cuotas Pactadas: </strong>
                    {dataModalDetalle.credito?.numero_cuotas}
                </p>
              <p>
                <strong>Forma Pago: </strong>
                {dataModalDetalle.credito?.forma_pago?.nombre}
              </p>
              <p>
                <strong>Utilidad: </strong>{" "}
                {dataModalDetalle.credito?.interes_porcentaje} %
              </p>
              <p>
                <strong>Calificación: </strong>
                {dataModalDetalle.credito?.cliente?.calificacion}
              </p>
              <p>
                <strong>Dirección: </strong>
                {dataModalDetalle.credito?.cliente?.direccion}
              </p>
              <p>
                <strong>Teléfono: </strong>
                {dataModalDetalle.credito?.cliente?.celular_1}
              </p>
              <p>
                <strong>Documento: </strong>
                {
                  dataModalDetalle.credito?.cliente
                      ?.documento_identificacion
                }
              </p>
              <p>
                <strong>Producto: </strong>
                {dataModalDetalle.credito?.producto}
              </p>
              <p>
                <strong>Descripción: </strong>
                {dataModalDetalle.credito?.descripcion}
              </p>
            </>
        ) : null,
      },
    ];

    // La pestaña "Cronograma" va primera en el orden, pero solo se agrega
    // (se renderiza) cuando dataModalDetalleCuotas trae cuotas.
    if (mostrarCronograma) {
      items.unshift({
        key: "0",
        label: "Cronograma",
        children: (
          <ModalCronograma
            dataModalDetalle={dataCreditoDetalle}
            dataModalDetalleAbonos={dataModalDetalleAbonos}
            dataModalDetalleCuotas={dataModalDetalleCuotas}
          />
        ),
      });
    }

    return (
      <ModalBottom>
        <ModalHeader icon="" noclose closeModalDetalle={closeModalDetalle}>
          {" "}
          {dataModalDetalle !== ""
            ? dataModalDetalle.credito.cliente.nombre_completo
            : ""}{" "}
        </ModalHeader>
        <ModalContent>
          <Tabs
              key={`${show}-${hasData ? dataModalDetalle.credito_id : "sin-credito"}-${mostrarCronograma}`}
              defaultActiveKey={mostrarCronograma ? "0" : "1"}
              onChange={callback}
              className="ow-tabs"
              items={items}
          />
        </ModalContent>
      </ModalBottom>
    );
  };

  // Render
  return (
    <div {...props}>
      {modalBottom()}
    </div>
  );
};
const ModalVerAbonos = styled(Modal_base)`
  ${styles}
`;
export default ModalVerAbonos;
